import { Pipe, PipeTransform } from '@angular/core';
import { HospitalType } from '../lib/facility-rate/models/hospital-types.enum';
import { SubmittalStatus, SubmittalTypes } from '../models/submittal-status.model';
import { SubmittalStatusEnum } from 'src/app/accountmanagers/submittals/model/enums/submittal-status.enum';
import { EmploymentTypeCode, lineOfBusinessWithoutOfferWorkflow } from '../models/enums/employment-type-code.enum';

const AYA_INCLUDE_STATUS_LIST = [
    SubmittalStatusEnum.PendingAMReview,
    SubmittalStatusEnum.PendingInformation,
    SubmittalStatusEnum.Queued,
    SubmittalStatusEnum.SendToClinical,
    SubmittalStatusEnum.SentToClient,
    SubmittalStatusEnum.CandidateNotSelected,
    SubmittalStatusEnum.CandidateWithdrawingFromSubmission,
    SubmittalStatusEnum.Interview,
    SubmittalStatusEnum.Offer
];

const APN_INCLUDE_STATUS_LIST = [...AYA_INCLUDE_STATUS_LIST, SubmittalStatusEnum.Placed];

@Pipe({
    name: 'submittalStatusFilter',
    standalone: true
})
export class SubmittalStatusFilterPipe implements PipeTransform {
    transform(
        statuses: SubmittalStatus[],
        hospitalType: HospitalType,
        newStatusFlagEnabled: boolean = false,
        isAPNSubmittal: boolean = false,
        employmentTypeCode: EmploymentTypeCode = null
    ): SubmittalStatus[] {
        if (!statuses || statuses.length === 0 || !hospitalType) {
            return [];
        }

        const modifiedAyaIncludeStatusList = [...AYA_INCLUDE_STATUS_LIST];
        const modifiedApnIncludeStatusList = [...APN_INCLUDE_STATUS_LIST];

        if (newStatusFlagEnabled) {
            if (
                isAPNSubmittal === false &&
                employmentTypeCode !== null &&
                lineOfBusinessWithoutOfferWorkflow.includes(employmentTypeCode)
            ) {
                modifiedAyaIncludeStatusList.push(SubmittalStatusEnum.Placed);
            }

            if (hospitalType === HospitalType.Locums) {
                modifiedAyaIncludeStatusList.push(SubmittalStatusEnum.NameClear);
                modifiedApnIncludeStatusList.push(SubmittalStatusEnum.NameClear);
            }

            if (isAPNSubmittal) {
                return statuses.filter((status: SubmittalStatus) => modifiedApnIncludeStatusList.includes(status.id));
            } else {
                return statuses.filter((status: SubmittalStatus) => modifiedAyaIncludeStatusList.includes(status.id));
            }
        }

        switch (hospitalType) {
            case HospitalType.PerDiem:
                return statuses.filter((s) => s.submittalTypeId === SubmittalTypes.PerDiem);
            case HospitalType.Staff:
                return statuses.filter((s) => s.submittalTypeId === SubmittalTypes.Staff);
            default:
                return statuses.filter((s) => s.submittalTypeId === SubmittalTypes.Regular);
        }
    }
}
